import Button from "@/Components/Button/Button";
import Icon from "@/Components/Icon/Icon";
import { useTranslation } from "react-i18next";

interface ErrorProps {
  refetch: () => void;
  message?: string;
  statusCode?: number;
}

const Error = ({ refetch, statusCode, message }: ErrorProps) => {
  const { t } = useTranslation();

  return (
    <div className="text-center">
      <Icon className="h-20 w-20 fill-error" variants="times" />
      {statusCode && (
        <div className="mt-[1rem]">
          {t("errorStatus", {
            statusCode,
          })}
        </div>
      )}
      <div className="mt-[1rem]"> {message || t("errorMessage")}</div>
      <div className="mt-[1.5rem]">
        <Button onClick={() => refetch()}>{t("tryAgain")}</Button>
      </div>
    </div>
  );
};

export default Error;
